// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider_4Xf"};